import { EntityAudit } from "@modernary/mui/components/audit";
import { EntityNotes } from "@modernary/mui/components/note";
import { type RouterOptions, RouterView } from "vue-router";

const names = {
  organizations: "Organization.Organizations",
  organizationList: "Organization.OrganizationList",
  organizationView: "Organization.OrganizationView",
  organizationNew: "Organization.OrganizationNew",
  organizationBase: "Organization.OrganizationBase",
  organizationAudit: "Organization.OrganizationAudit",
  organizationEdit: "Organization.OrganizationEdit",
  notes: "Organization.OrganzationNotes",
  noteEdit: "Organization.OrganizationNoteEdit",
  noteNew: "Organization.OrganizationNoteNew",
  electronicForms: "Organization.ElectronicForms",
  permitVersions: "Organization.PermitVersions",
};

export { names as organizationRouteNames };

const organizationsRoutes: RouterOptions["routes"] = [
  {
    path: "/organization",
    name: names.organizations,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.organizationList },
    children: [
      {
        path: "list",
        name: names.organizationList,
        meta: { title: "Organizations" },
        component: () => import("@/views/organization/OrganizationList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/organization/OrganizationBase.vue"),
        redirect: { name: names.organizationNew },
        props: true,
        children: [
          {
            path: "",
            name: names.organizationNew,
            meta: { title: "New Organization", isNew: true },
            component: () => import("@/views/organization/OrganizationEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.organizationBase,
        component: () => import("@/views/organization/OrganizationBase.vue"),
        redirect: { name: names.organizationView },
        children: [
          {
            path: "view",
            name: names.organizationView,
            meta: { title: "Organization View" },
            component: () => import("@/views/organization/OrganizationView.vue"),
          },
          {
            path: "edit",
            name: names.organizationEdit,
            meta: { title: "Organization Edit", isForm: true },
            component: () => import("@/views/organization/OrganizationEdit.vue"),
          },
          {
            path: "electronic-forms",
            name: names.electronicForms,
            meta: { title: "Organization Electronic Forms" },
            component: () => import("@/views/organization/OrganizationElectronicFormList.vue"),
          },
          {
            path: "permits",
            name: names.permitVersions,
            meta: { title: "Organization Permits" },
            component: () => import("@/views/organization/OrganizationPermitList.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Organization Notes" },
            component: {
              render: () => <EntityNotes idField="organizationId" routeNamePrefix="Organization.OrganizationNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Organization Note", isForm: true },
            component: () => import("@/views/organization/OrganizationNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Organization Note", isForm: true },
            component: () => import("@/views/organization/OrganizationNote.vue"),
          },
          {
            path: "activity",
            name: names.organizationAudit,
            meta: { title: "Organization Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="Organization" />,
            },
          },
        ],
      },
    ],
  },
];

export default organizationsRoutes;
